<style>
	@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Device Renewal" title="Renewal Logs" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end mb-3">
						<i class='bx bx-chevrons-left'></i> Back
					</a>
				</div>
			</div>

			<!-- Device info -->
			<div class="card mb-4" v-if="device_data">
				<div class="card-body">
					<h5 class="card-title">Device Information</h5>
					<div class="row">
						<div class="col-md-2"><strong>IMEI:</strong> {{ device_data.imei }}</div>
						<div class="col-md-2"><strong>Dealer:</strong> {{ device_data.dealer_name || '-' }}</div>
						<div class="col-md-3"><strong>Renewal Type:</strong> {{ Number(device_data.is_topup) === 1 ? 'Topup' : renewalTypeLabel(device_data.renewal_type) }} - {{ Number(device_data.is_topup) === 1 ? ((device_data.topup_validity || 0) + ' Day(s)') : ((device_data.certificate_validity || '-') + ' Year(s)') }}</div>
						<div class="col-md-2"><strong>Amount:</strong> {{ device_data.amount }}</div>
						<div class="col-md-2"><strong>Expiry Date:</strong> {{ device_data.expirationtime ? $filters.formatDateTime(device_data.expirationtime) : '-' }}</div>
					</div>
				</div>
			</div>

			<div class="card">
				<div class="card-body">
					<div class="col-md-12 project-list filter-sort">
						<div class="row">
							<div class="col-md-6 d-flex">
								<label class="d-flex listing-length"><span>Show</span>
									<select class="form-select" v-model="limit" @change="fetchRenewalLogs()">
										<option value="10">10</option>
										<option value="20">20</option>
										<option value="50">50</option>
										<option value="100">100</option>
									</select>
									<span>entries</span>
								</label>
							</div>
							<div class="col-md-6">
								<input
									type="text"
									class="form-control"
									placeholder="Search keyword..."
									v-model="keyword"
									@input="onKeywordSearch"
								/>
							</div>
						</div>
					</div>

					<div class="table-responsive product-table">
						<table class="display" id="renewal-log-table">
							<thead>
								<tr align="center">
									<th>Sl.No</th>
									<th>Log Date</th>
									<th>Type</th>
									<th>Status</th>
									<th>Remarks</th>
									<th>Staff</th>
								</tr>
							</thead>
							<tbody v-if="renewal_logs.length">
								<tr v-for="(log, index) in renewal_logs" :key="log.id" align="center">
									<td>{{ (from - 1) + index + 1 }}</td>
									<td>{{ log.log_date ? $filters.formatDateTime(log.log_date) : '-' }}</td>
									<td>{{ logTypeLabel(log.type) }}</td>
									<td>
										<span v-if="log.status == 1" class="badge rounded-pill bg-warning">Attended</span>
										<span v-else-if="log.status == 2" class="badge rounded-pill bg-success">Completed</span>
										<span v-else class="badge rounded-pill bg-secondary">{{ log.status }}</span>
									</td>
									<td>{{ log.remarks || '-' }}</td>
									<td>{{ log.staff_name || '-' }}</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td colspan="6" align="center">No logs available</td>
								</tr>
							</tbody>
						</table>
					</div>

					<caption v-if="renewal_logs.length" class="float-start mt-2 d-block d-lg-inline">
						Showing {{ from }} to {{ to }} of {{ total }} entries
					</caption>
					<nav aria-label="Page navigation" class="mt-2 float-end" v-if="pagination.length">
						<ul class="pagination">
							<li
								class="page-item"
								v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
								v-for="(page, index) in pagination"
								:key="page.label"
							>
								<a
									class="page-link"
									href="#"
									@click.prevent="fetchRenewalLogs(buildPageUrl(page.url))"
									tabindex="-1"
								>
									<span v-if="index === 0">Prev</span>
									<span v-else-if="index === pagination.length - 1">Next</span>
									<span v-else>{{ page.label }}</span>
								</a>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Renewal Logs",

	data() {
		return {
			token: "",
			device_id: null,
			device_data: null,
			renewal_logs: [],
			pagination: [],
			from: 0,
			to: 0,
			total: 0,
			limit: 20,
			keyword: "",
			keywordTimer: null,
			active_page_url: null,
			loading: false,
		};
	},

	mounted() {
		this.device_id = this.$route.params.id;
		if (!this.device_id) {
			this.$swal("", "Device ID is required", "error").then(() => this.$router.go(-1));
			return;
		}
		this.getToken();
		this.fetchRenewalLogs();
	},

	methods: {
		getToken() {
			if (localStorage.getItem("airotrack_staff")) {
				const airotrack_staff = JSON.parse(localStorage.getItem("airotrack_staff"));
				if (airotrack_staff.token) {
					this.token = airotrack_staff.token;
					this.user = airotrack_staff;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
		},

		buildQueryString(pageUrl = null) {
			const params = new URLSearchParams();
			params.append("device_id", this.device_id);
			params.append("limit", this.limit);
			if (this.keyword && this.keyword.trim()) {
				params.append("keyword", this.keyword.trim());
			}
			if (pageUrl) {
				const pageMatch = pageUrl.match(/[?&]page=(\d+)/);
				if (pageMatch) {
					params.append("page", pageMatch[1]);
				}
			}
			return "/staffs/renewalLogs?" + params.toString();
		},

		buildPageUrl(paginationPageUrl) {
			if (!paginationPageUrl) return this.buildQueryString();
			const pageMatch = paginationPageUrl.match(/[?&]page=(\d+)/);
			const params = new URLSearchParams();
			params.append("device_id", this.device_id);
			params.append("limit", this.limit);
			if (this.keyword && this.keyword.trim()) {
				params.append("keyword", this.keyword.trim());
			}
			if (pageMatch) {
				params.append("page", pageMatch[1]);
			}
			return "/staffs/renewalLogs?" + params.toString();
		},

		onKeywordSearch() {
			if (this.keywordTimer) clearTimeout(this.keywordTimer);
			this.keywordTimer = setTimeout(() => {
				this.fetchRenewalLogs();
				this.keywordTimer = null;
			}, 400);
		},

		fetchRenewalLogs(page_url = null) {
			this.getToken();
			const url = this.buildQueryString();
			page_url = page_url || url;
			this.active_page_url = page_url;
			this.loading = true;

			this.$axios
				.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					const data = res.data.data;
					if (res.data.status && data) {
						this.device_data = data.device_data || null;
						const logs = data.renewal_logs;
						if (logs && logs.data) {
							this.renewal_logs = logs.data;
							this.pagination = logs.links || [];
							this.from = logs.from ?? 0;
							this.to = logs.to ?? 0;
							this.total = logs.total ?? 0;
						} else {
							this.renewal_logs = [];
							this.pagination = [];
							this.from = 0;
							this.to = 0;
							this.total = 0;
						}
					} else {
						this.device_data = null;
						this.renewal_logs = [];
						this.pagination = [];
						this.from = 0;
						this.to = 0;
						this.total = 0;
					}
				})
				.catch((err) => {
					console.log(err);
					this.device_data = null;
					this.renewal_logs = [];
					this.pagination = [];
					this.from = 0;
					this.to = 0;
					this.total = 0;
				})
				.finally(() => {
					this.loading = false;
				});
		},

		renewalTypeLabel(type) {
			const map = { 1: "Normal", 2: "SIM Change", 3: "Replacement", 4: "Normal SIM Change", 5: "Extension" };
			return map[type] != null ? map[type] : (type != null ? "Type " + type : "-");
		},

		logTypeLabel(type) {
			const map = {
				1: "Renewal",
				2: "Enquiry",
				3: "Recharge Request",
				4: "Assign Recharge",
				5: "Recharge Completed",
				6: "Customer Info",
				7: "Dealer Info",
				8: "Payment Received",
				9: "To Safe Custody",
				10: "Recharge Request Viewed",
				11: "Extension",
				12: "Replacement",
				13: "Revoke",
				14: "Update",
				15: "Topup Request",
				16: "Topup Completed",
			};
			return map[type] != null ? map[type] : (type != null ? "Type " + type : "-");
		},
	},
};
</script>
